export enum ServiceType {
  AlloyKyc = 1,
  Salesforce = 2,
  FiServeCustomerCreate = 3,
  FiServeAccountCreate = 4,
  FiServeCustomerProfile = 5,
  Mando = 6,
  Q2Enrollment = 7,
  Q2ExistingUserCheck = 8,
  FiServeCustomerSearch = 9,
  Socure = 10,
  AlloyDocV = 15,
  AlloyEntity = 16
}
